export const BackgroundDisabled = '#E9F1F5';
export const BorderXtraDark = '#98B2C1';
export const contentPrimary = '#1C1B1F';
export const contentSecondary = '#4B6A81';
export const contentDisabled = '#B5CBD6';
export const label = '#243B57';
export const primary = '#3A83F9';
export const primaryDark = '#2978AE';
export const primaryLight = '#CEEBFF';
export const primaryBackground = '#F9FBFF';
export const borderLight = '#D4E4EC';
export const lightMode = '#FFFFFF';
export const darkBlue = '#0858d9';
export const red = '#FF312E';
export const green = '#2ECC71';
export const black = '#333333';
export const B100 = '#E3EEFF';
export const B200 = '#C4DAFD';
export const B400 = '#3A83F9';
export const B500 = '#0760ED';
export const N900 = '#333333';
export const N700 = '#707070';
export const N600 = '#7B7B7B';
export const N400 = '#ADADAD';
export const N200 = '#D6D6D6';
export const N100 = '#D4E4EC';
export const N50 = '#F5F5F5';
export const N0 = '#FFFFFF';
export const N2 = '#E3E8EA';
export const R900 = '#8E0C01';
export const R700 = '#DF1401';
export const R400 = '#F93A3A';
export const R500 = '#FE6D61';
export const R300 = '#FC6363';
export const R200 = '#FEA29A';
export const R50 = '#FFECEB';
export const G1200 = '#10361F';
export const G700 = '#267D49';
export const G500 = '#36B368';
export const G200 = '#72CA95';
export const G50 = '#F5FBF7';
export const Y900 = '#775403';
export const Y700 = '#C78D05';
export const Y400 = '#F9B310';
export const Y500 = '#FABC2A';
export const Y200 = '#FBD374';
export const Y50 = '#FEF9EB';
export const lightGrey = '#FCFCFC';
export const lightBlue = '#F9FBFF';
export const facebookBlue = '#053889';
export const whatsappGreen = '#2ecc71';
export const altoGrey = '#CECECE';
export const lavenderBlue = '#BFD6FD';
export const chromeYellow = '#FDCA40';
export const MARKET_COLOR_GREY = '#849DAD';
export const MARKET_COLOR_BASE = '#445B70';
